import { useQuery } from "@apollo/client"
import { ALL_TOURNAMENT_TYPES } from "../queries/allTournamentTypes"

export interface TournamentType {
  id: number
  name: string
  description?: string
  private?: boolean
  status?: number
  minPlayers?: number
  urlImage?: string
  maxTopPlayers?: number
  multiplier?: number
  winnerPoints?: number
  loserPoints?: number
  drawPoints?: number
  socialRequired?: boolean
  urlUpdate?: string
  storeTournaments?: number
  canBeDouble?: boolean
  totalTournaments?: number
}

export const useAllTournamentTypes = () => {
  const { data, loading, error, refetch } = useQuery<{
    allTournamentTypes: TournamentType[]
  }>(ALL_TOURNAMENT_TYPES, {
    errorPolicy: "all",
  })

  return {
    tournamentTypes: data?.allTournamentTypes || [],
    loading,
    error,
    refetch,
  }
}
